export enum TipoEventoTimeline {
  Acao = 0,
  Substituicao = 1,
  Lotacao = 2,
}
